import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { useReactToPrint } from 'react-to-print';
import Helper from '../../Helper';
import Alert from '../sub/dialog';
import moment from 'moment';
import './Bill.css'; // Import CSS for print styling
import PrintHeaderBillList from './sub/PrintHeaderBillList';
import PrintFooter from './sub/PrintFooter';
import { Previewer } from 'pagedjs';
import { MDBTable, MDBTableHead, MDBTableBody } from 'mdb-react-ui-kit';


const TransportPrint = ({ data }) => {
    const navigate = useNavigate();

    const [company, setCompany] = useState({
        name: '',
        name_en: '',
        address: '',
        phone: '',
        email: '',
        website: '',
        taxid: '', bankaccount: '', bankaccountname: '', bankname: '', bankaccounttype: ''

    });

    const [userinfo, setUserinfo] = useState({});
    const [customer, setCustomer] = useState({});
    const alert = useRef();
    const printRef = useRef();
    let { name, id } = useParams();
    const [summarydata, setSummarydata] = useState({});
    const [transportAccount, setTransportAccount] = useState({});
    const [transportJobList, setTransportJobList] = useState([]);
    const setError = (message) => alert.current.showerror(message);
    const header = { name: "ใบวางบิล" }
    const handlePrint = useReactToPrint({
        documentTitle: header.name,
        contentRef: printRef,
    });


    const getTransportAccount = async (transportname) => {

        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/getTransportAccount_bill/${transportname}`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${Helper.gettoken()}`,
                    'Content-Type': 'application/json'
                }
            });

            if (response.ok) {
                const data = await response.json();
                if (!data.transportAccount) {
                    setError('ไม่มีข้อมูลการขนส่ง');
                    return;
                }

                setSummarydata({
                    totalamount: data.transportAccount.totalamount,
                    totalnetamount: data.transportAccount.totalnetamount,
                    totalvatamount: data.transportAccount.totalvatamount,
                    totalwhtamount: data.transportAccount.totalwhtamount,
                    totalpaidamount: data.transportAccount.totalpaidamount
                });
                setTransportAccount(data.transportAccount);
                fetchCustomer(data.transportAccount.customerid);
                fetchuser(data.transportAccount.modify_user);
                setTransportJobList(data.bills);
      
            } else {
                const data = await response.json();
                setError(data.message || 'Failed to fetch transport list');
            }
        } catch (err) {
            setError('An error occurred while fetching the transport list.');
        }
    }



    const fetchCustomer = async (customerid) => {
        try {

            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/Getcustomerbyid/${customerid}`, {
                headers: { 'Authorization': `Bearer ${Helper.gettoken()}`, }
            });
            const data = await response.json();
            if (data && data.customer) setCustomer(data.customer);
        } catch (error) {
            setError('Error fetching customer profile:', error);
        }
    };
    const fetchuser = async (username) => {
        try {

            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/Getuserinfo/${username}`, {
                headers: { 'Authorization': `Bearer ${Helper.gettoken()}`, }
            });
            const data = await response.json();
            if (data && data.userinfo) setUserinfo(data.userinfo);
        } catch (error) {
            setError('Error fetching customer profile:', error);
        }
    };
    const fetchCompany = async () => {
        try {

            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/GetcompanyProfile`, {
                headers: { 'Authorization': `Bearer ${Helper.gettoken()}`, }
            });
            const data = await response.json();
            if (data) setCompany(data);
        } catch (error) {
            setError('Error fetching company profile:', error);
        }
    };



    useEffect(() => {
        // Get the token from sessionStorage


        if (!["account", "billing", "admin"].includes(Helper.getuserrole())) {
            navigate('/main');
            return;
        }
        if (!name) {
            navigate('/main');
            return;
        }
        fetchCompany();
        getTransportAccount(name);

        // Initialize Paged.js preview after all data is loaded

    }, []);

    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', flexDirection: 'column' }}>
            <style type="text/css" media="print">{"\
  @page {\ size:A4;\ }\
"}</style>
            <Alert ref={alert} />
            <button className='btn btn-info mb-4 mt-4' onClick={handlePrint}>Print</button>

            <div ref={printRef} className="bill print-container list"  >



                {Array.from({ length: Math.ceil(transportJobList.length / 10) }, (_, pageIndex) => (
                    <div key={pageIndex} className="print-page mb-2">
                        <PrintHeaderBillList company={company}
                            header={{ ...header, title: "ต้นฉบับ", page: `หน้า ${pageIndex + 1}/${Math.ceil(transportJobList.length / 10) + (Math.ceil(transportJobList.length / 10) && transportJobList.length % 10 < 7 ? 0 : 1)}` }}
                            transportAccount={transportAccount}
                            customer={customer}
                            userinfo={userinfo}
                        />
                        <div className="print-content">
                            <MDBTable className='header-table'>
                                <MDBTableHead style={{ backgroundColor: '#f2f2f2' }}>
                                    <tr>
                                        <th className='p-2'>เลขที่เอกสาร</th>
                                        <th className='p-2' style={{ textAlign: "center",width:"10%" }}>วันที่เอกสาร</th>
                                        <th className='p-2' style={{ textAlign: "center",width:"18%" }}>วันที่ครบกำหนด</th>
                                        <th className='p-2' style={{ textAlign: "right",width:"20%" }}>จำนวนเงินวางบิล</th>
                                        <th className='p-2' style={{ textAlign: "right",width:"10%" }}>WHT</th>
                                    </tr>
                                </MDBTableHead>
                                <MDBTableBody>
                                    {transportJobList.slice(pageIndex * 10, (pageIndex + 1) * 10).map((job, subIndex) => (
                                        <tr key={subIndex}>
                                          
                                            <td className='p-2'>{pageIndex * 10 + subIndex + 1}.<b className='ms-1'>{job.name}</b></td>
                                            <td className='p-2' style={{ textAlign: "center" }}>{moment(job.jobdateobj).format("DD/MM/YYYY")}</td>
                                            <td className='p-2' style={{ textAlign: "center" }}>{moment(job.duedateobj).format("DD/MM/YYYY")}</td>
                                            <td className='p-2' style={{ textAlign: "right" }}>{Helper.formatnumber(job.totalnetamount)}</td>
                                            <td className='p-2' style={{ textAlign: "right" }}>{Helper.formatnumber(job.totalwhtamount)}</td>
                                        </tr>
                                    ))}
                                </MDBTableBody>
                            </MDBTable>
                        </div>
                        {pageIndex + 1 === Math.ceil(transportJobList.length / 10) && transportJobList.length % 10 < 7 ? (
                            <PrintFooter transportAccount={transportAccount}
                                customer={customer}
                                company={company}
                                userinfo={userinfo} header={{ LastPage: true, isbill: true }} />
                        ) : null}
                    </div>
                ))}

                {transportJobList.length % 10 >= 7 && (
                    <div className="print-page mb-2">
                        <PrintHeaderBillList company={company}
                            header={{ ...header, title: "ต้นฉบับ", page: `หน้า ${Math.ceil(transportJobList.length / 10) + 1}/${Math.ceil(transportJobList.length / 10) + 1}` }}
                            transportAccount={transportAccount}
                            customer={customer}
                            userinfo={userinfo}
                        />

                        <PrintFooter transportAccount={transportAccount}
                            customer={customer}
                            company={company}
                            userinfo={userinfo} header={{ LastPage: true, isbill: true }} />
                    </div>
                )}

            </div>
        </div >
    );
};

export default TransportPrint;